var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.457,
    height: 29.165,
    viewBox: "0 0 36.457 29.165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6898",
    "data-name": "Path 6898",
    d: "M18.228,12.937A5.468,5.468,0,1,0,23.7,18.405,5.468,5.468,0,0,0,18.228,12.937ZM32.811,7.468H28.436A1.619,1.619,0,0,1,27,6.429L25.866,3.037A1.622,1.622,0,0,0,24.426,2h-12.4a1.62,1.62,0,0,0-1.438,1.035L9.459,6.429A1.62,1.62,0,0,1,8.02,7.468H3.646A3.656,3.656,0,0,0,0,11.114V27.52a3.656,3.656,0,0,0,3.646,3.646H32.811a3.656,3.656,0,0,0,3.646-3.646V11.114A3.656,3.656,0,0,0,32.811,7.468ZM18.228,27.52a9.114,9.114,0,1,1,9.114-9.114A9.114,9.114,0,0,1,18.228,27.52ZM31.9,13.3a1.276,1.276,0,1,1,1.276-1.276A1.276,1.276,0,0,1,31.9,13.3Z",
    transform: "translate(0 -2)",
    fill: "#ddd",
    opacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraDark);
export default __webpack_public_path__ + "static/media/cameraDark.8193c8cb8166e5ba8a8edd8f30d694dd.svg";
export { ForwardRef as ReactComponent };